import { Button } from '@/components/ui/button'
import { useAuth } from '@/lib'
import { Loader2 } from 'lucide-react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { OnboardingLayout } from '../onboarding/onboarding-layout'

const POLL_INTERVAL_MS = 2000

export function AccountProvisioningPendingScreen() {
	const { user, refreshSession, signOut } = useAuth()
	const { t } = useTranslation('auth')

	useEffect(() => {
		const interval = setInterval(() => {
			void refreshSession()
		}, POLL_INTERVAL_MS)

		return () => clearInterval(interval)
	}, [refreshSession])

	// Full reload (rather than a router navigation) so `beforeLoad`
	// re-evaluates against a fresh router context, same as the
	// onboarding-completion flow in onboarding-page.tsx.
	useEffect(() => {
		if (user?.isProvisioned) {
			window.location.reload()
		}
	}, [user?.isProvisioned])

	return (
		<OnboardingLayout>
			<div className="flex flex-col items-center gap-6 py-4 text-center">
				<Loader2 className="size-8 animate-spin text-brand-600" />
				<div className="flex flex-col gap-2">
					<h1 className="text-xl font-semibold">
						{t('provisioning.title', 'Hold on a second')}
					</h1>
					<p className="text-muted-foreground">
						{t('provisioning.description', "We're preparing your account. This should only take a moment.")}
					</p>
				</div>
				<Button variant="ghost" onClick={() => void signOut()}>
					{t('provisioning.logout', 'Log out')}
				</Button>
			</div>
		</OnboardingLayout>
	)
}
